import { render, staticRenderFns } from "./product_pick.vue?vue&type=template&id=6d6972fd&scoped=true"
import script from "./product_pick.vue?vue&type=script&lang=js"
export * from "./product_pick.vue?vue&type=script&lang=js"
import style0 from "./product_pick.vue?vue&type=style&index=0&id=6d6972fd&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6972fd",
  null
  
)

export default component.exports